/**
 * Application route constants
 * Use these enums instead of hardcoded route strings throughout the application
 */

export enum AppRoutes {
  // Public routes
  HOME = '/',
  ABOUT = '/about',
  SEARCH = '/search',
  ORGANIZATIONS = '/charities',
  CHARITY_DETAIL = '/charity',
  PROJECTS = '/projects',
  CONTACT = '/contact',

  // Auth routes
  LOGIN = '/login',
  REGISTER = '/register',
  DASHBOARD = '/dashboard',

  // Fund management routes
  FUND_DASHBOARD = '/fund/dashboard',
  FUND_DONATE = '/fund/donate',
  FUND_GRANT = '/fund/grant',
  FUND_DISTRIBUTE = '/fund/distribute',
  FUND_TRANSFER = '/fund/transfer',
  FUND_CURRENCY_CONVERSION = '/fund/currency-conversion',
  FUND_ACTIVITY = '/fund/activity',
  FUND_MANAGE_RECURRING = '/fund/manage-recurring',
  FUND_DASHBOARD_PERMISSION_ERROR = '/fund/dashboard/permission-error',

  // Profile & Settings
  PROFILE = '/profile',
  SETTINGS = '/settings',
}
